import axios from 'axios'

const host = '/ones/api/v1'

const http = axios.create({
  baseURL: host,
})

interface IUploadS3 {
  events: any
  appId: string
}

export const uploadTos3 = async ({ events, appId }: IUploadS3) => {
  const res = await http.get<{
    data: {
      actionUrl: string
      key: string
    }
  }>(`/rrweb/get-s3-upload-url`, {
    params: {
      appId,
    },
  })

  const { actionUrl, key } = res?.data?.data || {}

  await axios.put(actionUrl, events)

  return key
}

interface ICreateFeedback {
  app_id?: string
  uid?: string
  username?: string
  email?: string
  description?: string
  title?: string
  replay_url?: string
  countryCode: string
}

/**
 * 创建 feedback
 * @param data
 * @returns
 */
export const createFeedback = async (data: ICreateFeedback) => {
  return http.post<{
    data: string
  }>(`/rrweb/create-v2`, data)
}
